import { getEnvString } from 'src/utils'

export function getSetupPolicy(accountId: string, userGroup: string) {
  return {
    Version: getEnvString('REACT_APP_API_VERSION'),
    Statement: [
      {
        Sid: 'VisualEditor0',
        Effect: 'Allow',
        Action: [
          'iam:CreatePolicy',
          'iam:AddUserToGroup',
          'iam:AttachUserPolicy',
          'iam:DeleteUser',
          'iam:GetUser',
          'iam:DetachUserPolicy',
          'iam:CreateUser',
          'iam:TagUser',
          'iam:TagPolicy',
          'iam:CreateAccessKey',
          'iam:AttachGroupPolicy',
        ],
        Resource: [
          `arn:aws:iam::${accountId}:policy/${userGroup}/*`,
          `arn:aws:iam::${accountId}:group/${userGroup}`,
          `arn:aws:iam::${accountId}:user/*`,
        ],
        Condition: {
          'ForAllValues:StringEquals': {
            'aws:TagKeys': userGroup,
          },
        },
      },
    ],
  }
}

export function getAdminPolicy(
  region: string,
  accountId: string,
  instanceId: string,
  userGroup: string,
) {
  return {
    Version: getEnvString('REACT_APP_API_VERSION'),
    Statement: [
      {
        Sid: 'VisualEditor0',
        Effect: 'Allow',
        Action: [
          'iam:CreateLoginProfile',
          'iam:DeleteAccessKey',
          'iam:AddUserToGroup',
          'iam:AttachUserPolicy',
          'connect:DescribeUser',
          'iam:DeleteUser',
          'iam:RemoveUserFromGroup',
          'iam:GetUser',
          'iam:DetachUserPolicy',
          'iam:CreateUser',
          'iam:TagUser',
          'iam:CreateAccessKey',
        ],
        Resource: [
          `arn:aws:iam::${accountId}:group/${userGroup}`,
          `arn:aws:iam::${accountId}:user/*`,
          `arn:aws:connect:${region}:${accountId}:instance/${instanceId}/agent/*`,
        ],
        Condition: {
          'ForAllValues:StringEquals': {
            'aws:TagKeys': [userGroup],
          },
        },
      },
      {
        Sid: 'VisualEditor1',
        Effect: 'Allow',
        Action: 'connect:ListUsers',
        Resource: `arn:aws:connect:${region}:${accountId}:instance/${instanceId}`,
      },
    ],
  }
}

export function getConnectPolicy(
  region: string,
  accountId: string,
  instanceId: string,
) {
  return {
    Version: getEnvString('REACT_APP_API_VERSION'),
    Statement: [
      {
        Sid: 'Statement1',
        Effect: 'Allow',
        Action: 'connect:GetFederationToken',
        Resource: [
          `arn:aws:connect:${region}:${accountId}:instance/${instanceId}/user/\${aws:userid}`,
        ],
      },
      {
        Sid: 'Statement5',
        Effect: 'Allow',
        Action: [
          'connect:UpdateUserPhoneConfig',
          'connect:GetContactAttributes',
        ],
        Resource: [
          `arn:aws:connect:${region}:${accountId}:instance/${instanceId}/*`,
        ],
      },
      {
        Sid: 'VisualEditor0',
        Effect: 'Allow',
        Action: 'connect:DescribeUser',
        Resource: `arn:aws:connect:${region}:${accountId}:instance/${instanceId}/agent/*`,
      },
      {
        Sid: 'VisualEditor1',
        Effect: 'Allow',
        Action: 'connect:ListUsers',
        Resource: `arn:aws:connect:${region}:${accountId}:instance/${instanceId}`,
      },
    ],
  }
}
